const KNOWN_ERRORS = new Set([
  "ACCESS_DENIED",
  "TOO_MANY_ROWS",
  "QUERY_ERROR",
  "INTERNAL",
]);

export function reportTitleKey(
  type: string,
  widget: string | null | undefined
): string {
  return type === "ANALYTICS_WIDGET" && widget
    ? `reports.widget.${widget}`
    : `reports.type.${type}`;
}

export function reportErrorKey(code: string | null | undefined): string {
  return `reports.error.${code && KNOWN_ERRORS.has(code) ? code : "INTERNAL"}`;
}
